export const InfoSession = () => {
	return {
    authorization: localStorage.getItem('authorization'),
    fullName: localStorage.getItem('full_name'),
    isAuth: ('authorization' in localStorage),
  };
}
export const OpenSession = (data : any) => {
	return {
    authorization: localStorage.setItem('authorization', data.authorization),
    fullName: localStorage.setItem('full_name',data.full_name),
    status: localStorage.setItem('status',data.status),
    username: localStorage.setItem('username',data.username),
  };
}

export const CloseSession = () => {
	localStorage.clear();
}

export const SaveProfile = (data : any) => {
  localStorage.setItem('profile', JSON.stringify(data))
}
export const GetProfile = () => {
  return JSON.parse(localStorage.getItem("profile") || 'null');
}

export const SaveNewOrder = (data : any) => {
  localStorage.setItem('neworder', JSON.stringify(data))
}
export const GetNewOrder = () => {
  return JSON.parse(localStorage.getItem("neworder") || 'null');
}
 